import { motion } from 'framer-motion';
import { Award, Shield, Leaf } from 'lucide-react';

const CertificationsSection = () => {
  const certifications = [
    { icon: <Award size={28} strokeWidth={1} />, title: 'ISO 9001:2015', description: 'Quality Management' },
    { icon: <Leaf size={28} strokeWidth={1} />, title: 'ISO 14001:2015', description: 'Environmental Management' },
    { icon: <Shield size={28} strokeWidth={1} />, title: 'ISO 45001:2018', description: 'Occupational Health & Safety' },
  ];

  return (
    <section
      className="py-20 px-6 md:px-12 lg:px-24 bg-white border-y border-[#E5E0D5]"
      data-testid="certifications-section"
    >
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Left Text */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center md:text-left"
          >
            <p className="text-xs uppercase tracking-[0.3em] font-medium text-[#2C6E63] mb-2" data-testid="certifications-overline">
              Certifications
            </p>
            <p className="font-heading text-xl text-[#2D3436] italic" data-testid="certifications-tagline">
              "Committed to quality, sustainability and safety."
            </p>
          </motion.div>

          {/* Certifications */}
          <div className="flex flex-wrap items-center justify-center md:justify-end gap-8">
            {certifications.map((cert, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="flex items-center gap-3 group"
                data-testid={`certification-${index}`}
              >
                <div className="text-[#2C6E63] group-hover:scale-110 transition-transform duration-300" data-testid={`certification-icon-${index}`}>
                  {cert.icon}
                </div>
                <div>
                  <p className="font-heading text-[#2D3436]" data-testid={`certification-title-${index}`}>{cert.title}</p>
                  <p className="text-xs text-[#6B6560]" data-testid={`certification-description-${index}`}>{cert.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertificationsSection;
